/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_LabelInputs */



/**
* | output |
* | --- |
* | "Push notifications" |
*
* @param {Notifications_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_label = /** @type {((inputs?: Notifications_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notifications push")
	if (locale === "es") return /** @type {LocalizedString} */ ("Notificaciones push")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Notificações push")
	if (locale === "it") return /** @type {LocalizedString} */ ("Notifiche push")
	return /** @type {LocalizedString} */ ("Push notifications")
});